import { useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetUserList } from "../../../../hooks/api/queries/useSettings";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";
import { useGetOrderList } from "../../../../hooks/api/queries/useOrder";

export const useSalesTransactions = ({ isUserListEnabled = true }) => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByDate,
    filterByKey,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [isModal, setIsModal] = useState({
    isEndOfDay: search.get("endOfDay") ? true : false,
    isReturn: false,
  });
  const { data: userList, isLoading: isLoadingUsers } =
    useGetUserList(isUserListEnabled);

  const {
    isLoading: isFetchingSalesTransactions,
    data: salesTransactions,
    refetch: handleFetchSalesTransactions,
  } = useGetOrderList({ queries, isEnabled: true });

  const filterReturnStatus = (value) => {
    filterByKey("return_status", value);
  };

  const filterByInitiator = (value) => {
    filterByKey("initiator_id", value);
  };

  const filterByStoreType = (value) => {
    filterByKey("order_source", value);
  };

  const filterByStatus = (value) => {
    filterByKey("status", value);
  };

  return {
    isFetchingSalesTransactions,
    storeList,
    metaDetails: salesTransactions?.meta || {},
    salesTransactions: salesTransactions?.data || [],
    search,
    userList: userList || [],
    isLoadingUsers,
    isModal,
    setSearch,
    filterBySearch,
    filterByDate,
    setIsModal,
    filterByInitiator,
    handleFetchSalesTransactions,
    filterByStoreId,
    filterByStoreType,
    filterByStatus,
    gotoPage,
    filterReturnStatus,
  };
};
